import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const userServices = {
  fetchUsers: () => axiosInstance.get(endpoints.tokenEndPoints.allUsers),
  deleteUser: (id) =>
    axiosInstance.delete(`${endpoints.tokenEndPoints.user}/${id}`),
  getUserDetails: (id) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.userDetails}/${id}`),
  updateUser: (id, data) =>
    axiosInstance.patch(`${endpoints.tokenEndPoints.updateUser}/${id}`, data),
  addUser: (data) => axiosInstance.post(endpoints.tokenEndPoints.addUser, data),
  verifyKyc: (id) =>
    axiosInstance.put(`${endpoints.tokenEndPoints.verifyKyc}/${id}`),
};
